//Manual-light
// // import the library
// import { library } from '@fortawesome/fontawesome-svg-core';

// // import your icons
// import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

// library.add(
//   faArrowLeft
//   // more icons go here
// );

//Auto-heavy
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faArrowLeft,
  faEnvelope,
  faPhone,
  faMagnifyingGlass,
  faFilter,
  faArrowDown,
  faPlus,
  faCheck,
  faXmark,
  faPlug,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  fab,
  faPlug,
  faArrowLeft,
  faEnvelope,
  faPhone,
  faMagnifyingGlass,
  faFilter,
  faArrowDown,
  faPlus,
  faCheck,
  faXmark
);
